export const SUPPORTED_CHANNELS_FOR_NETCHEX = [
  {
    name: 'Email',
    type: 'EMAIL',
  },
  {
    name: 'SMS',
    type: 'SMS',
  },
  {
    name: 'Push',
    type: 'PUSH',
  },
] as const;
